import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Chart from "react-apexcharts";
import "bootstrap/dist/css/bootstrap.min.css";

const SkillsPage = () => {
  const skills = [
    { name: "HTML/CSS", percentage: 95 },
    { name: "JavaScript", percentage: 80 },
    { name: "React", percentage: 75 },
    { name: "Angular", percentage: 70 },
    { name: "MySQL", percentage: 80 },
  ];

  const getChartOptions = (skill) => ({
    chart: {
      type: "radialBar",
    },
    plotOptions: {
      radialBar: {
        hollow: {
          size: "70%",
          image: undefined,
          imageOffsetX: 0,
          imageOffsetY: 0,
          position: "front",
        },
        dataLabels: {
          name: {
            fontSize: "20px",
          },
          value: {
            fontSize: "30px",
            color: "red",
          },
        },
      },
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        type: "horizontal",
        gradientToColors: ["#ff0303"],
        stops: [0, 100],
      },
    },
    stroke: {
      lineCap: "round",
    },
    labels: [skill.name],
  });

  return (
    <Container fluid className="bg-dark text-white py-5" id="skills">
      <h1 className="display-3 text-center mb-4 font-weight-bold">My Skills</h1>
      <Row className="justify-content-center">
        {skills.map((skill, index) => (
          <Col key={index} md={6} lg={4} className="mb-4">
            <div className="text-center">
              <h5 className="mb-3 text-danger">{skill.name}</h5>
              <Chart
                options={getChartOptions(skill)}
                series={[skill.percentage]}
                type="radialBar"
                height={300}
              />
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
};

export default SkillsPage;
